<template>
    <div class="InvitedUsersTable">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="头像/昵称">
                <template slot-scope="scope">
                    <div class="photo_name_box">
                        <img :src="scope.row.customericonurl" alt="">
                        <span>{{scope.row.customername}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column property="ordercount" label="成交订单数" align='center'></el-table-column>
            <el-table-column property="ordermoney" label="成交订单金额" align='center'></el-table-column>
            <el-table-column property="lastinvitetime" label="邀请时间" align='center'></el-table-column>
            <el-table-column label="邀请状态" align='center'>
                <template slot-scope="scope">
                    <span :class="scope.row.invitestatus === 0 ? 'yellow' : 'green'">{{scope.row.invitestatus === 0 ? '邀请中' : '已邀请'}}</span>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" ref="page" @getList="findinvitedUserList"></page>
    </div>
</template>

<script>
import Page from 'base/page/page'
import {getUserInviteList} from 'api/cPurchaseApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: "InvitedUsersTable",
    props: ['InvitedUsersListData'],
    data() {
        return {
            total: 0,
            tableData: []
        }
    },
    mounted() {},
    methods: {
        // getOrderList() {
        //     this.$message.success(`${this.page.page}`)
        // },
        // 查询用户详情下邀请用户列表
        findinvitedUserList() {
            this.setLoading(true)
            var params = {
                innerid: this.$route.query.innerid,
                assinnerid: this.$route.query.assinnerid,
            }
            getUserInviteList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        InvitedUsersListData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                console.log('InvitedUsersListData:', this.InvitedUsersListData)
                this.tableData = this.InvitedUsersListData.content
                this.total = this.InvitedUsersListData.pageinfo.rowCount
            })
        }
    },
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss">
    .InvitedUsersTable{
        .yellow{
            color: #E6A23C;
        }
        .green{
            color: #67C23A;
        }
        .photo_name_box{
            display: flex;
            align-items: center;
            img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
    }
</style>